import { render, staticRenderFns } from "./JSelectKaoshi.vue?vue&type=template&id=29b52865&scoped=true"
import script from "./JSelectKaoshi.vue?vue&type=script&lang=js"
export * from "./JSelectKaoshi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b52865",
  null
  
)

export default component.exports